import { render, staticRenderFns } from "./Navheader.vue?vue&type=template&id=a40fafc4&scoped=true&"
import script from "./Navheader.vue?vue&type=script&lang=js&"
export * from "./Navheader.vue?vue&type=script&lang=js&"
import style0 from "./Navheader.vue?vue&type=style&index=0&id=a40fafc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40fafc4",
  null
  
)

export default component.exports